import { DestroyRef, Directive, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { BEZUGSRECHT_ROUTES, BezugsrechtService } from '@zero/bezugsrecht/domain';
import { AbstractUserMessagesHolderService } from '@zero/shared/util-abstract-services';
import { BezugsrechtData, CorporateActionType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Directive()
export class BezugsrechtBase implements OnInit {
  public model?: BezugsrechtData;
  public rootUrl?: string;

  public readonly commonRoutes = commonRoutes;
  public readonly BEZUGSRECHT_ROUTES = BEZUGSRECHT_ROUTES;

  protected service = inject(BezugsrechtService);
  protected router = inject(Router);
  protected msgService = inject(AbstractUserMessagesHolderService);
  protected translateService = inject(TranslocoService);
  protected destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.rootUrl = `${commonRoutes.postlogin.bezugsrecht}/${this.service.isin}`;
    this.service.bezugsrechtData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (!data || this.service.redirectInvalidData([CorporateActionType.KAP], this.router, data.asset, data.announcement)) {
        return;
      }

      this.model = data;
    });
  }

  public loadPreview(shareAmount?: number): void {
    this.msgService.clearAllMessages();

    if (!this.model?.announcement) {
      this.msgService.addErrorMessage(this.translateService.translate('bezugsrecht-service.error'));
      return;
    }

    const { announcement } = this.model;
    const { ereignisnummer, avisTyp } = announcement;
    this.service.loadDirectivePreview(ereignisnummer, avisTyp, shareAmount);
  }

  public back = (): void => {
    this.router.navigateByUrl(this.rootUrl);
  };
}
